"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringifyErrorObject = void 0;
var _ansis = _interopRequireDefault(require("ansis"));
var _isObject = require("./isObject");
var NEWLINE_CHAR = '\r\n';
var stringifyErrorObject = function(error) {
    var leftPad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var result = leftPad;
    if (error.stack) {
        var stackLinesAsArray = error.stack.split('\n').map(function(line) {
            return _ansis.default.dim("".concat(leftPad).concat(line));
        });
        result += stackLinesAsArray.join(NEWLINE_CHAR);
    } else {
        // When stack is not defined then just simulate atleast its first line from name and message
        result += _ansis.default.bold("".concat(error.name || 'Error', ": ").concat(error.message));
    }
    if ((0, _isObject.isObject)(error.cause)) {
        result += "".concat(NEWLINE_CHAR).concat(leftPad, "Cause:").concat(NEWLINE_CHAR);
        result += stringifyErrorObject(error.cause, leftPad);
    }
    return result;
};
exports.stringifyErrorObject = stringifyErrorObject; //# sourceMappingURL=stringifyErrorObject.js.map
